"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var Celo = function Celo(props) {
  return react_1.default.createElement("svg", Object.assign({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    enableBackground: "new 0 0 250 250",
    version: "1.1",
    viewBox: "0 0 250 250",
    xmlSpace: "preserve"
  }), react_1.default.createElement("circle", {
    cx: "125",
    cy: "125",
    r: "125",
    fill: "#FCFF52"
  }), react_1.default.createElement("path", {
    d: "M188.9 60.7H60.7v128.2h128.2v-44.8h-21.3c-7.3 16.3-23.8 27.7-42.7 27.7-26 0-47.1-21.3-47.1-47.1 0-25.9 21.1-47 47.1-47 19.3 0 35.8 11.7 43.1 28.4h20.9V60.7z"
  }));
};
exports.default = Celo;